<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400 fade-in-section">
        <img :src="importedImg1" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400 fade-in-section">
        <img :src="importedImg2" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400 fade-in-section">
        <img :src="importedImg3" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400 fade-in-section">
        <img :src="importedImg4" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400 fade-in-section">
        <img :src="importedImg5" alt="" class="imgItem" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/bacgianghbtcompany/components/img/index1.png";
import importedImg2 from "@/page/bacgianghbtcompany/components/img/index2.png";
import importedImg3 from "@/page/bacgianghbtcompany/components/img/index3.png";
import importedImg4 from "@/page/bacgianghbtcompany/components/img/index4.png";
import importedImg5 from "@/page/bacgianghbtcompany/components/img/index5.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      altText: "图片",
    };
  },
  mounted() {
    this.InitPage();
  },
  methods: {
    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.3
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    }
  },
};
</script>

<style scoped>
.contentBox {
  display: flex;
  flex-direction: column;
  background: #FCFCFC;
}
img {
  display: block;
}
.flexBox{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.imgBox{
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
  min-height: 400px;
}

.imgItem {
  width: 100%;
  margin: 0;
}

.flexBox:nth-child(1) .imgBox,
.flexBox:nth-child(3) .imgBox,
.flexBox:nth-child(5) .imgBox {
  padding: 100px 150px;
}

.flexBox:nth-child(2) .imgBox,
.flexBox:nth-child(4) .imgBox  {
  padding: 100px 0px;
}
</style>
